// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MDInput from "components/MDInput";
import * as moment from 'moment';
import Select from 'react-select';
import { TextField, Checkbox } from '@mui/material';
import * as service from '../../../services/service';

function MaterialReceipt() {
    const [state, setState] = useState({ billno: '', transportcharges: '', loadingcharges: '', totalamount: '' });
    const [supplierData, setSupplierData] = useState([]);
    const [supplierId, setSupplierId] = useState('');
    const [poMRData, setPOMRData] = useState([]);
    const [grnData, setGRNData] = useState([]);
    const [purchaseOrderData, setPurchaseOrderData] = useState('');
    const [purchaseOrderId, setPurchaseOrderId] = useState('');
    const [requisitionIds, setRequisitionIds] = useState([]);
    const [materialIds, setMaterialIds] = useState([]);
    const [receivedQuantity, setReceivedQuantity] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [rate, setRate] = useState([]);
    const [grnDate, setGRNDate] = useState(new Date());
    const [testCertificateFile, setTestCertificateFile] = useState('');
    const [materialInspectionFile, setMaterialInspectionFile] = useState('');
    // const [purchaseDate, setPurchaseDate] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    // const navigate = useNavigate();
    const getSupplier = () => {
        fetch(
            service.SUPPLIER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.supplierId, label: item.supplierName }));
                setSupplierData(data2);
            });
    };
    const getPurchaseOrdersBySupplier = (id) => {
        if (id > 0) {
            fetch(
                service.GET_PURCHASE_ORDER_BY_SUPPLIER,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        SupplierId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    // setPOData(result);
                    const data2 = result.map((item) => ({ value: item.purchaseOrderId, label: item.purchaseOrderNo }));
                    setPurchaseOrderData(data2);
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };

    const getPurchaseOrdersMRByPOId = (id) => {
        if (id > 0) {
            fetch(
                service.GET_PURCHASE_ORDER_MR_BY_POID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        PurchaseOrderId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setPOMRData(result);
                    result.forEach((element, index) => {
                        materialIds[index] = element.materialId;
                        setMaterialIds([...materialIds]);
                        requisitionIds[index] = element.requisitionId;
                        setRequisitionIds([...requisitionIds]);
                        rate[index] = element.rate;
                        setRate([...rate]);
                        isSelected[index] = false;
                        setIsSelected([...isSelected]);
                        receivedQuantity[index] = 0;
                        setReceivedQuantity([...receivedQuantity]);
                    });
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };

    const getGRNByPO = (id) => {
        if (id > 0) {
            fetch(
                service.GET_GRN_BY_PO,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        PurchaseOrderId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setGRNData(result);
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };

    function getExtension(filename) {
        return filename.split('.').pop()
    }

    const validate = () => {
        let isValid = true;
        const errs = {};
        const maxSize = 5120; // in KB = 5MB
        if (!supplierId) {
            isValid = false;
            errs[".supplier"] = "Please select supplier";
        }
        if (!purchaseOrderId) {
            isValid = false;
            errs[".purchaseorder"] = "Please select purchase order";
        }
        // if (!requisitionId) {
        //     isValid = false;
        //     errs[".requisitionId"] = "Please select material";
        // }
        if (!grnDate) {
            isValid = false;
            errs[".grnDate"] = "Please select date";
        }
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".requisitionId"] = "Please select material";
        }
        // if (state.quantity) {
        //     let recQ = 0;
        //     grnData.forEach(element => {
        //         recQ += parseFloat(element.receivedQuantity);
        //     });
        //     if ((parseFloat(state.quantity) + parseFloat(recQ)) > parseFloat(state.poquantity)) {
        //         isValid = false;
        //         errs[".quantity"] = "Received quantity should not be greater than Ordered Quantity";
        //     }
        // }

        if (testCertificateFile && getExtension(testCertificateFile.name).toLowerCase() !== 'pdf'
            && getExtension(testCertificateFile.name).toLowerCase() !== 'jpg'
            && getExtension(testCertificateFile.name).toLowerCase() !== 'jpeg'
            && getExtension(testCertificateFile.name).toLowerCase() !== 'png'
            && getExtension(testCertificateFile.name).toLowerCase() !== 'docx') {
            isValid = false;
            errs[".testCertificateFile"] = "Please upload pdf/jpg/jpeg/png/docx file";
        }
        if (materialInspectionFile && getExtension(materialInspectionFile.name).toLowerCase() !== 'pdf'
            && getExtension(materialInspectionFile.name).toLowerCase() !== 'jpg'
            && getExtension(materialInspectionFile.name).toLowerCase() !== 'jpeg'
            && getExtension(materialInspectionFile.name).toLowerCase() !== 'png'
            && getExtension(materialInspectionFile.name).toLowerCase() !== 'docx') {
            isValid = false;
            errs[".materialInspectionFile"] = "Please upload pdf/jpg/jpeg/png/docx file";
        }

        if (testCertificateFile && testCertificateFile.size / 1024 > maxSize) {
            isValid = false;
            errs[".testCertificateFile"] = "File size limit 5 MB";
        }
        if (materialInspectionFile && materialInspectionFile.size / 1024 > maxSize) {
            isValid = false;
            errs[".materialInspectionFile"] = "File size limit 5 MB";
        }
        setErrors(errs);
        return isValid;
    }
    const submitHandler = e => {
        // eslint-disable-next-line
        console.log(materialIds); // do not remove
        e.preventDefault();
        const errs = {};
        let flag = true;
        if (validate()) {
            setLoading(true);
            materialIds.forEach((element, index) => {
                if (isSelected[index] === true) {
                    const formData = new FormData();
                    formData.append("GRNDate", (new Date(grnDate)).toUTCString());
                    formData.append("PurchaseOrderId", purchaseOrderId.value);
                    formData.append("RequisitionId", requisitionIds[index]);
                    formData.append("MaterialId", element);
                    formData.append("ReceivedQuantity", receivedQuantity[index]);
                    formData.append("BillNo", state.billno);
                    formData.append("TransportCharges", state.transportcharges);
                    formData.append("LoadingCharges", state.loadingcharges);
                    formData.append("TotalAmount", state.totalamount);
                    formData.append("AddedBy", JSON.parse(sessionStorage.getItem('userData')).employeeId);
                    formData.append("TestCertificate", testCertificateFile);
                    formData.append("MaterialInspectionReport", materialInspectionFile);
                    fetch(
                        service.ADD_GRN,
                        {
                            method: 'POST',
                            // headers: {
                            //     'Accept': 'application/json',
                            //     'Content-Type': 'application/json'
                            // },
                            body: formData
                        })
                        .then(res => res.json())
                        .then(result => {
                            if (result.messageType === 'Failed') {
                                flag = false;
                                // eslint-disable-next-line
                                alert(result.message);
                            }
                            else {
                                flag = false;
                                errs[".invalid"] = result.message;
                                setErrors(errs);
                            }
                        });
                }
            });

            if (flag) {
                // eslint-disable-next-line
                alert("Data Saved Successfully");
                setMaterialIds([]);
                setIsSelected([]);
                window.location.reload(false);
            }
            setLoading(false);
        }
    }

    const handleDelete = (id) => {
        // eslint-disable-next-line
        if (window.confirm("Do you want to delete this record?")) {
            fetch(
                service.DELETE_GRN_DETAILS_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        GRNId: id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        window.location.reload();
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                });
        }
    };
    useEffect(() => {
        setLoading(true);
        getSupplier();
        setLoading(false);
    }, []);

    const supplierChangeHandler = (ev) => {
        setSupplierId(ev);
        setPurchaseOrderId(null);
        getPurchaseOrdersBySupplier(ev.value);
        setMaterialIds([]);
        setIsSelected([]);
        setRequisitionIds([]);
    }
    const purchaseOrderChangeHandler = (ev) => {
        setPurchaseOrderId(ev);
        getGRNByPO(ev.value);
        getPurchaseOrdersMRByPOId(ev.value);
        setMaterialIds([]);
        setIsSelected([]);
        setRequisitionIds([]);
        // const found = poData.find(obj =>
        //     obj.purchaseOrderId === ev.value
        // );

        // setMaterialId(found.materialId);
        // setPurchaseDate(moment(found.purchaseOrderDate).format("DD/MM/YYYY"));
        // setState({
        //     ...state, poquantity: found.quantity
        // });
    }

    const receivedQuantityChangeHandler = (event, index, qty) => {
        if (Number.isNaN(parseFloat(event.target.value))) {
            // eslint-disable-next-line
            alert("Please enter numbers only");
            event.target.value = ""; // eslint-disable-line no-param-reassign
        }
        else if (parseFloat(event.target.value) > qty) {
            // eslint-disable-next-line
            alert("Received quantity should not be greater than Ordered Quantity");
            event.target.value = ""; // eslint-disable-line no-param-reassign
        }
        else {
            let updatedObject = receivedQuantity[index];
            updatedObject = event.target.value;
            receivedQuantity[index] = updatedObject;
        }

        setReceivedQuantity([...receivedQuantity]);
    };
    const handleCheckboxChange = (checked, index) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);
    }

    const changeHandler = (event) => {
        // if (event.target.name === 'quantity') {
        //     if (Number.isNaN(parseFloat(event.target.value))) {
        //         // eslint-disable-next-line
        //         alert("Please enter numbers only");
        //         event.target.value = ""; // eslint-disable-line no-param-reassign
        //     }
        // }
        // let amount = 0;
        if (event.target.name === 'transportcharges') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }
        if (event.target.name === 'loadingcharges') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
            // else {
            //     materialIds.forEach((index) => {
            //         if (isSelected[index] === true) {
            //             amount += (Number.isNaN(parseFloat(rate[index])) * Number.isNaN(parseFloat(receivedQuantity[index])));    
            //         }
            //         alert(amount);
            //     });
            //     amount = Number.isNaN(parseFloat(amount)) + Number.isNaN(parseFloat(state.transportcharges)) + Number.isNaN(parseFloat(state.loadingcharges));
            //     alert(amount);
            //     setState({ ...state, totalamount: amount });
            // }           
        }
        if (event.target.name === 'totalamount') {
            if (Number.isNaN(parseFloat(event.target.value))) {
                // eslint-disable-next-line
                alert("Please enter numbers only");
                event.target.value = ""; // eslint-disable-line no-param-reassign
            }
        }

        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                headers: {                  
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
                body: formData
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Material Receipt Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table aria-label="simple table" style={{ width: '80%' }}>
                                    <TableRow>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '50%' }}>
                                            <Select
                                                options={supplierData}
                                                name="supplier"
                                                value={supplierId}
                                                onChange={supplierChangeHandler}
                                                placeholder="Select Supplier"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".supplier"]}</div>
                                        </TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                options={purchaseOrderData}
                                                name="purchaseorder"
                                                value={purchaseOrderId}
                                                onChange={purchaseOrderChangeHandler}
                                                placeholder="Select Purchase Order"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".purchaseorder"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <br />
                                <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                            <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                            <TableCell style={{ fontWeight: 'bold' }}>Ordered Quantity</TableCell>
                                            <TableCell style={{ fontWeight: 'bold' }}>Rate</TableCell>
                                            <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                                            <TableCell style={{ fontWeight: 'bold' }}>Received Quantity</TableCell>
                                        </TableRow>

                                        <TableBody>
                                            {poMRData.map((row, index) => (
                                                <TableRow
                                                    key={row.requisitionId}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell>
                                                        <Checkbox checked={isSelected[index] || false}
                                                            onChange={(e) => handleCheckboxChange(e.target.checked, index)} id="chkSelect" />
                                                    </TableCell>
                                                    <TableCell>{row.material}</TableCell>
                                                    <TableCell>{row.quantity}</TableCell>
                                                    <TableCell>{row.rate}</TableCell>
                                                    <TableCell>{row.amount}</TableCell>
                                                    <TableCell>
                                                        <MDInput label="Received Quantity" fullWidth value={receivedQuantity[index] || ''}
                                                            name="receivedQuantity"
                                                            onChange={ev => receivedQuantityChangeHandler(ev, index, row.quantity)}
                                                            id="receivedQuantity"
                                                        />
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".receivedQuantity"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <div style={{ fontSize: '12px', color: 'red' }}>{errors[".requisitionId"]}</div>
                                </TableContainer>
                                <br /><br />
                                <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <MDInput label="Bill No" fullWidth value={state.billno || ''}
                                                    name="billno"
                                                    onChange={changeHandler}
                                                    id="billno"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".billno"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                Receipt Date
                                                <DatePicker
                                                    id="grnDate"
                                                    selected={grnDate}
                                                    onChange={date => setGRNDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".grnDate"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <MDInput label="Transport Charges" fullWidth value={state.transportcharges || ''}
                                                    name="transportcharges"
                                                    onChange={changeHandler}
                                                    id="transportcharges"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".transportcharges"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <MDInput label="Loading Charges" fullWidth value={state.loadingcharges || ''}
                                                    name="loadingcharges"
                                                    onChange={changeHandler}
                                                    id="loadingcharges"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".loadingcharges"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <MDInput label="Total Amount" fullWidth value={state.totalamount || ''}
                                                    name="totalamount"
                                                    onChange={changeHandler}
                                                    id="totalamount"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".totalamount"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Test Certificate File (File Size 5 MB)
                                                <br />
                                                <TextField
                                                    id="testCertificateFile"
                                                    type="file"
                                                    onChange={ev => setTestCertificateFile(ev.target.files[0])}
                                                    style={{ width: 200 }}

                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".testCertificateFile"]}</div>
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Material Inspection Report File (File Size 5 MB)
                                                <br />
                                                <TextField
                                                    id="materialInspectionFile"
                                                    type="file"
                                                    onChange={ev => setMaterialInspectionFile(ev.target.files[0])}
                                                    style={{ width: 200 }}

                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialInspectionFile"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </TableContainer>
                                {userDesignation === 'General Manager' || userDesignation === 'Manager - Purchase'
                                    || userDesignation === 'Manager - Store' || userDesignation === 'MD'
                                    || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Assistant - Store' ?
                                    <MDBox mt={4} mb={1} textAlign="center">
                                        {loading ? <Oval
                                            heigth="20"
                                            width="20"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>
                                        }
                                        {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                    </MDBox>
                                    : null}
                            </Card>
                            <br />
                            {loading ? <Oval
                                heigth="100"
                                width="100"
                                color='grey'
                                ariaLabel='loading'
                            /> :
                                <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell colSpan="8" align="center" style={{ fontWeight: 'bold' }}>
                                                Material Receipt Details
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell width="5%" style={{ fontWeight: 'bold' }}>GRN No</TableCell>
                                            <TableCell width="5%" style={{ fontWeight: 'bold' }}>GRN Date</TableCell>
                                            <TableCell width="15%" style={{ fontWeight: 'bold' }}>Bill No</TableCell>
                                            <TableCell width="30%" style={{ fontWeight: 'bold' }}>Material</TableCell>
                                            <TableCell width="15%" style={{ fontWeight: 'bold' }}>Received Quantity</TableCell>
                                            <TableCell width="10%" style={{ fontWeight: 'bold' }}>Test Certificate</TableCell>
                                            <TableCell width="10%" style={{ fontWeight: 'bold' }}>Material Inspection Report</TableCell>
                                            {userDesignation === 'General Manager' || userDesignation === 'Manager - Purchase'
                                                || userDesignation === 'Manager - Store' || userDesignation === 'Assistant - Store' ?
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                : null}
                                        </TableRow>
                                        <TableBody>
                                            {grnData.map((row) => (
                                                <TableRow
                                                    key={row.grnId}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">{row.grnNo}</TableCell>
                                                    <TableCell component="th" scope="row">{moment(row.grnDate).format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell component="th" scope="row">{row.billNo}</TableCell>
                                                    <TableCell component="th" scope="row">{row.material}</TableCell>
                                                    <TableCell component="th" scope="row">{row.receivedQuantity}</TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <MDButton onClick={() => handleDownload(row.testCertificateFileName, row.testCertificateFilePath)}>{row.testCertificateFileName}</MDButton>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <MDButton onClick={() => handleDownload(row.materialInspectionReportFileName, row.materialInspectionReportFilePath)}>{row.materialInspectionReportFileName}</MDButton>
                                                    </TableCell>
                                                    {userDesignation === 'General Manager' || userDesignation === 'Manager - Purchase'
                                                        || userDesignation === 'Manager - Store' || userDesignation === 'Assistant - Store' ?
                                                        <TableCell><MDButton onClick={() => handleDelete(row.grnId)}>Delete</MDButton></TableCell>
                                                        : null}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default MaterialReceipt;